import React from 'react';
import './css/footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin, faFiverr, faTwitter } from '@fortawesome/free-brands-svg-icons';

function Footer() {
  return (
    <footer>
      <div className="social-icons">
      <a href="https://github.com/ErnestH1" target="_blank"><FontAwesomeIcon icon={faGithub} /></a>
      <a href="https://www.linkedin.com/in/ernest-hanson-5b958411b/" target="_blank"><FontAwesomeIcon icon={faLinkedin} /></a>
      <a href="https://twitter.com" target="_blank"><FontAwesomeIcon icon={faTwitter} /></a>

      </div>
      <div className="footer-text">
        © 2023 Ernest Hanson. All Rights Reserved.
      </div>
    </footer>
  );
}

export default Footer;
